import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";

import { Button, Form, Modal } from "react-bootstrap";
import { architectTypes, initVanueData } from "../../Constants";
import TagsInputList from "../TagsInputList";
import {
  formatArea,
  isValidEmail,
  isValidPhone,
  normalizeUsPhone,
  showToast,
} from "../../utils/helpers";
import { API } from "../../utils/Apis";
import {
  createNewVenueAction,
  updateVenueAction,
} from "../../Services/Store/Actions/VanuesAction";
import { useDispatch } from "react-redux";
import CustomButton from "../Button";
import AddressInput from "../AddressInput";

import { VenueTypes } from "../../Constants/Interfaces";
import useUnsavedChanges from "../../Hooks/useUnsavedChanges";
import ConfirmationModal from "../ConfirmationModal";

interface AddVanueType {
  show: boolean;
  item?: VenueTypes & { id: string };
  closeModal: Function;
}

const AddVenue: React.FC<AddVanueType> = ({ show, item, closeModal }) => {
  const maxContentLimit = 1150;
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [remainingLimit, setRemaningLimit] = useState(maxContentLimit);

  const [data, setData] = useState({
    ...initVanueData,
  });
  const [errors, setErrors] = useState({
    name: "",
    type: "",
    email: "",
    phone: "",
    description: "",
    address: "",
    spaces: "",
    architectTags: "",
    area: "",
  });

  const guard = useUnsavedChanges(data, () => closeModal());

  const onChange = (field: string, value: string) => {
    const contentLength = value.length;

    if (field === "description" && contentLength >= maxContentLimit) {
      return;
    }

    setData({
      ...data,
      [field]: value,
    });
  };

  const validateForm = () => {
    let vanueErr = false;
    const err = {
      type: "",
      name: "",
      address: "",
      email: "",
      phone: "",
      spaces: "",
      architectTags: "",
      area: "",
      description: "",
    };

    if (!data.name || data.name === "") {
      err.name = "Please enter the venue name.";
      vanueErr = true;
    }

    if (!data.address || data.address === "") {
      err.address = "Please enter the venue address.";
      vanueErr = true;
    }

    if (!data.email || data.email === "") {
      err.email = "Please enter the venue email.";
      vanueErr = true;
    } else if (data.email && !isValidEmail(data.email)) {
      err.email = "Please enter a valid email address.";
      vanueErr = true;
    }

    if (!data.phone || data.phone === "") {
      err.phone = "Please enter a phone number.";
      vanueErr = true;
    } else if (data.phone && !isValidPhone(data.phone)) {
      err.phone = "Please enter a valid phone number.";
      vanueErr = true;
    }

    // if (!data.architectTags || data.architectTags.length === 0) {
    //   err.architectTags = "Please enter number of spaces you vanue have";
    //   vanueErr = true;
    // }

    // if (!data.totalSpaces || data.totalSpaces === "") {
    //   err.spaces = "Please enter number of spaces does your vanue have";
    //   vanueErr = true;
    // }

    if (!data.area || data.area === "") {
      err.area = "Please enter the size of the property.";
      vanueErr = true;
    }

    if (!data.description || data.description === "") {
      err.description = "Please enter a description for the venue.";
      vanueErr = true;
    }

    if (data.description && data.description.length > maxContentLimit) {
      vanueErr = true;
      err.description = `The description of the venue should be within ${maxContentLimit} characters.`;
    }

    setErrors(err);

    return vanueErr;
  };

  const saveVenue = () => {
    const isError = validateForm();

    console.log("isError :", isError, errors);

    if (!isError && !loading) {
      setLoading(true);

      const tempData = {
        name: data.name,
        address: data.address,
        email: data.email,
        phone: data.phone,
        // totalSpaces: data.totalSpaces,
        description: data.description,
        lat: data.lat,
        lng: data.lng,
        area: data.area,
        status: data.status,
      };

      if (item && item.id) {
        const temp2 = { ...tempData, id: item.id };

        updateVenueAction(temp2, dispatch)
          .then((res) => {
            if (res.type === "success") {
              // saved → reset baseline so closing won't re-prompt
              guard.setBaseline(data);
            }
            showToast(res.type, res.message);
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      } else {
        const architectTags =
          data.architectTags?.map((tag: any) => tag.text) || [];

        if (architectTags.length > 0) {
          tempData.architectTags = architectTags;
        }

        createNewVenueAction(tempData, dispatch)
          .then((res) => {
            closeModal();
            showToast(res.type, res.message);
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      }
    }
  };

  const getVenueItem = (id: string) => {
    if (!fetching) {
      setFetching(true);

      API.getVanue(id)
        .then((res) => {
          // console.log("RES :", res);

          if (res.type === "success") {
            const architectTags =
              res.data && res.data.tags
                ? res.data.tags.filter(
                    (item, index) => item.type === "architect",
                  )
                : [];

            const loaded = {
              ...initVanueData,
              ...res.data,
              architectTags,
              // The API returns area as a decimal string (e.g. "77.00"); strip
              // trailing zeros so the form shows "77" like the venue list does.
              area:
                res.data?.area === null || res.data?.area === undefined
                  ? ""
                  : formatArea(res.data.area),
            };
            setData(loaded);
            // baseline = freshly-loaded venue, so edits are detected from here
            guard.setBaseline(loaded);
          }
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => setFetching(false));
    }
  };

  useEffect(() => {
    const contentLength = data.description.length;
    const remains = maxContentLimit - contentLength;

    setRemaningLimit(contentLength);
  }, [data.description]);

  useEffect(() => {
    if (item && item.id) {
      getVenueItem(item.id);
    }
  }, []);

  console.log("Data :", item);

  return (
    <Modal show={show} onHide={guard.requestClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {item && item?.id ? "Update Venue" : "Add Venue"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <p className="required-note m-0">
            <span className="required-star">*</span> Required
          </p>

          <Form.Check
            type="switch"
            id="venue-status"
            label={data.status === "published" ? "Publish" : "Draft"}
            checked={data.status === "published"}
            onChange={(e) => {
              if (e.target.checked) {
                onChange("status", "published");
              } else {
                onChange("status", "draft");
              }
            }}
          />
        </div>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="form-group">
              <label>
                Venue name<span className="required-star">*</span>
              </label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={data.name}
                onChange={(e) => onChange("name", e.target.value)}
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="form-group">
              <label>
                Venue address<span className="required-star">*</span>
              </label>

              <AddressInput
                type="fullObject"
                requireSelection
                address={data.address}
                onChange={(address: any) => {
                  console.log("address :", address);
                  if (typeof address === "object") {
                    setData({
                      ...data,
                      ...address,
                      zipcode: address.postalCode,
                    });
                  } else {
                    onChange("address", address);
                  }
                }}
              />

              {/* <input
                type="text"
                name="address"
                className="form-control"
                value={data.address}
                onChange={(e) => onChange("address", e.target.value)}
              /> */}
              {errors.address && (
                <span className="error">{errors.address}</span>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>
                Email<span className="required-star">*</span>
              </label>
              <input
                type="text"
                name="email"
                className="form-control"
                value={data.email}
                onChange={(e) => onChange("email", e.target.value)}
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>
                Phone<span className="required-star">*</span>
              </label>

              <PhoneInput
                country={"us"}
                onlyCountries={["us"]}
                preferredCountries={["us"]}
                value={data.phone}
                onChange={(phone) =>
                  onChange("phone", normalizeUsPhone(phone))
                }
                containerClass="form-control form-phone-field"
              />

              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>
          </div>

          {/* <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Number of spaces</label>
              <input
                type="text"
                name="totalSpaces"
                className="form-control"
                value={data.totalSpaces}
                onChange={(e) => onChange("totalSpaces", e.target.value)}
              />

              {errors.spaces && <span className="error">{errors.spaces}</span>}
            </div>
          </div> */}

          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="form-group">
              <label>
                Property Size (Sqft)<span className="required-star">*</span>
              </label>
              <input
                type="number"
                name="area"
                className="form-control"
                placeholder="Total area in sq ft"
                value={data.area}
                onChange={(e) => onChange("area", e.target.value)}
              />

              {errors.area && <span className="error">{errors.area}</span>}
            </div>
          </div>

          <TagsInputList
            systemItems={architectTypes}
            field="architect"
            type="Venue"
            venueId={item?.id || ""}
            items={data.architectTags}
            label="Architecture"
            placeHolder="Select an architecture style…"
            updateTags={(items: any) => onChange("architectTags", items)}
            error={errors.architectTags}
          />

          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="form-group">
              <label>
                Description<span className="required-star">*</span>
              </label>
              <textarea
                rows={5}
                name="description"
                className="form-control"
                value={data.description}
                onChange={(e) => onChange("description", e.target.value)}
              />
              <span className="remaining-content-text">
                {remainingLimit} of {maxContentLimit}
              </span>
              {errors.description && (
                <span className="error">{errors.description}</span>
              )}
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-xs-12">
            <CustomButton
              isLoading={loading}
              title="Save"
              onClick={() => saveVenue()}
            />
          </div>
        </div>
      </Modal.Body>

      {guard.showConfirm && (
        <ConfirmationModal
          show={guard.showConfirm}
          heading="Discard changes?"
          message="Are you sure you want to close? You may lose your changes."
          closeModal={guard.cancelClose}
          buttons={[
            {
              text: "Keep editing",
              variant: "outline-dark",
              className: "confirmation-cancel-btn",
              action: guard.cancelClose,
            },
            {
              text: "Discard Changes",
              action: guard.confirmDiscard,
            },
          ]}
        />
      )}
    </Modal>
  );
};

export default AddVenue;
